module.exports = __webpack_public_path__ + "img/js-todo.51789be2.png";